<template>
    <RenderlessPagination
        :data="data"
        :limit="limit"
        :keep-length="keepLength"
        @pagination-change-page="onPaginationChangePage"
        v-slot="slotProps"
    >   
        <ul 
        v-bind="$attrs"
            aria-label="Pagination"
            v-if="slotProps.computed.total > slotProps.computed.perPage"
        class="pagination justify-content-end">
            <li class="page-item pagination-page-nav">
                <a v-if="slotProps.computed.prevPageUrl"
                :disabled="!slotProps.computed.prevPageUrl"
                v-on="slotProps.prevButtonEvents"                
                class="page-link" href="#">Previous</a>
            </li>

            <li
            :aria-current="slotProps.computed.currentPage ? 'page' : null"
                v-for="(page, key) in slotProps.computed.pageRange"
                :key="key"
                class="page-item pagination-page-nav" :class="{'active': slotProps.computed.currentPage == page}">
                    <a 
                    v-on="slotProps.pageButtonEvents(page)"                
                    class="page-link" href="#">{{page}}</a>
            </li>

            <li class="page-item pagination-page-nav">
                <a v-if="slotProps.computed.nextPageUrl" 
                :disabled="!slotProps.computed.nextPageUrl"
                v-on="slotProps.nextButtonEvents"      
                class="page-link" href="#">Next</a>
            </li>
        </ul>
    </RenderlessPagination>
</template>

<script>
import RenderlessPagination from 'laravel-vue-pagination/src/RenderlessPagination.vue';

export default {
    inheritAttrs: false,

    emits: ['pagination-change-page'],

    components: {
        RenderlessPagination
    },

    props: {
        data: {
            type: Object,
            default: () => {}
        },
        limit: {
            type: Number,
            default: 0
        },
        keepLength: {
            type: Boolean,
            default: false
        },
    },

    methods: {
        onPaginationChangePage(page) {
            this.$emit('pagination-change-page', page);
        }
    }
}
</script>